export const ORDER_CUSTOMER_SELECT_KEY = Symbol('orderCustomerSelect')
export const ORDER_PRODUCT_ADD_KEY = Symbol('orderProductAdd')
export const ORDER_SERVICE_ADD_KEY = Symbol('orderServiceAdd')
